function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 24,
    viewBox: "0 0 80 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 24,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.65,0V4.27H80V0Z",
    transform: "translate(0)",
    style: {
      fill: "#ff3c34"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,16.78a4.72,4.72,0,0,1-1.81,1.27,6.59,6.59,0,0,1-4,.23,4.59,4.59,0,0,1-1.53-.69A3.84,3.84,0,0,1,.48,16.28,4.09,4.09,0,0,1,0,14.22a4.74,4.74,0,0,1,.49-2.15A4.57,4.57,0,0,1,1.85,10.5a6.26,6.26,0,0,1,2.06-1,9.54,9.54,0,0,1,2.55-.32L8,9.25a6.63,6.63,0,0,1,1,.08V9a1.65,1.65,0,0,0-.22-.9,1.87,1.87,0,0,0-.6-.62,2.36,2.36,0,0,0-.85-.35,4.28,4.28,0,0,0-1-.1,8.31,8.31,0,0,0-2.38.35,8.69,8.69,0,0,0-2.35,1V5a7.46,7.46,0,0,1,1.36-.59A11.47,11.47,0,0,1,4.67,4,13.74,13.74,0,0,1,6.89,3.8a6.05,6.05,0,0,1,4.73,1.69A6.64,6.64,0,0,1,13.15,10v8H9.1ZM9,12c-.1,0-.29-.05-.57-.08s-.63,0-1,0a4.8,4.8,0,0,0-2.54.5,1.61,1.61,0,0,0-.56.6,1.56,1.56,0,0,0-.19.79c0,1.14.7,1.71,2.09,1.71a3.08,3.08,0,0,0,1-.16,2.79,2.79,0,0,0,.87-.46,2.31,2.31,0,0,0,.61-.74,2,2,0,0,0,.24-1Z",
    transform: "translate(0)",
    style: {
      fill: "#324ab5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.79,0H20.1V4.27h3.61V7.6H20.1v5.45a2.49,2.49,0,0,0,.41,1.54c.29.41,1.39,1,3.28.35V18a6.71,6.71,0,0,1-2.69.55,6.51,6.51,0,0,1-2.51-.43A4.11,4.11,0,0,1,17,17a4.54,4.54,0,0,1-.9-1.81,9.79,9.79,0,0,1-.26-2.35V0Z",
    transform: "translate(0)",
    style: {
      fill: "#324ab5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.38,4.27h4.3v8a2.73,2.73,0,0,0,.58,1.85,2.19,2.19,0,0,0,.78.54,2.31,2.31,0,0,0,.94.14,2.58,2.58,0,0,0,1.16-.25,2.83,2.83,0,0,0,.87-.66,2.85,2.85,0,0,0,.54-1,3.88,3.88,0,0,0,.2-1.12V4.27H40V18.08H35.91l-.16-1.48a5.36,5.36,0,0,1-1.81,1.31,5.62,5.62,0,0,1-2.35.51A5,5,0,0,1,27.78,17a5.8,5.8,0,0,1-1.4-4.16Z",
    transform: "translate(0)",
    style: {
      fill: "#324ab5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2,4.27h4.16l.12,1.5a4.4,4.4,0,0,1,1.75-1.32A5.57,5.57,0,0,1,51.47,4a5.9,5.9,0,0,1,2.69.58,5.76,5.76,0,0,1,2,1.58,6.86,6.86,0,0,1,1.17,2.26,9.47,9.47,0,0,1,.38,2.64A7.8,7.8,0,0,1,57,14.39a6.79,6.79,0,0,1-4.06,3.68,8.54,8.54,0,0,1-2.6.44,6.76,6.76,0,0,1-1.68-.18c-.44-.12-.83-.23-1.19-.35v6H43.19V4.27Zm4.28,10.16a4.49,4.49,0,0,0,2.46.56,3.06,3.06,0,0,0,1.37-.25,3.11,3.11,0,0,0,1.13-.8,4.11,4.11,0,0,0,.91-2.78,5.31,5.31,0,0,0-.17-1.32,3.25,3.25,0,0,0-.51-1.14,2.67,2.67,0,0,0-.89-.78,3.28,3.28,0,0,0-2.63,0,2.81,2.81,0,0,0-.93.71,3.18,3.18,0,0,0-.56,1,3.47,3.47,0,0,0-.19,1.15v3.68Z",
    transform: "translate(0)",
    style: {
      fill: "#324ab5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,4.27h4.15l.12,1.49a5.8,5.8,0,0,1,3.91-1.51,6.28,6.28,0,0,1,1.06.06V8.1s-2.41-1-4,.35a3.76,3.76,0,0,0-.94,2.8v6.83H60ZM69.22,8.1s-2.4-1-4,.35a3.72,3.72,0,0,0-1,2.8v6.83H60V4.27h4.15l.12,1.49a5.8,5.8,0,0,1,3.91-1.51,6.28,6.28,0,0,1,1.06.06",
    transform: "translate(0)",
    style: {
      fill: "#324ab5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.34,4.27h4.3V18.08h-4.3Z",
    transform: "translate(0)",
    style: {
      fill: "#324ab5"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "premcalc-static/media/logo.569d38476a6c817990ff41d49609c0e4.svg";
export { ForwardRef as ReactComponent };